export const roles = [
    'Administrativo',
    'Coordinador',
    'Developer',
    'Directivo',
    'Manager',
    'Otro',
]